import GoogleMapReact from 'google-map-react';
import { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';

export const DEFAULT_CENTER_COORDINATES: Coordinates = {
  lat: 51.165691,
  lng: 10.451526,
};

export const DEFAULT_ZOOM = 6;

export const DEFAULT_ZOOM_ON_DEALER = 13;

export const DEFAULT_Y_OFFSET = 0.002;

export const DEFAULT_BOUNDS: GoogleMapReact.Bounds = {
  nw: {
    lat: 0,
    lng: 0,
  },
  ne: {
    lat: 0,
    lng: 0,
  },
  sw: {
    lat: 0,
    lng: 0,
  },
  se: {
    lat: 0,
    lng: 0,
  },
};

export const getMapOptions = (isMobile: boolean) => ({
  fullscreenControl: false,
  zoomControl: !isMobile,
  gestureHandling: 'greedy',
});

export const getBootstrapURLKeys = (marketGoogleKey: string, language: string) => ({
  key: marketGoogleKey,
  libraries: ['places'],
  language,
});
